import axios from 'axios';
import _groupBy from 'lodash.groupby';
import _sortBy from 'lodash.sortby';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import { setCaptchaEuScript } from '../utils';
import { getFormRenderToken } from '../services/anti-bot';
import { isCaptchaEnabled } from '../services/captcha';

Vue.component('career-component', {
    props: {
        siteHandle: {
            type: String,
        },
        jobs: {
            type: Array,
        },
        captchaEuPublicKey: {
            value: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            countryHandle: this.siteHandle,
            formCompleted: false,
            submitting: false,
            ready: false,
            privacyCheckBoxValue: false,
            privacyClicked: false,
        };
    },

    computed: {
        // a computed getter
        orderedJobs: function () {
            // `this` points to the vm instance

            var orderedJobs = _groupBy(this.jobs, 'country');

            for (const key in orderedJobs) {
                if (orderedJobs.hasOwnProperty(key)) {
                    var element = orderedJobs[key];
                    element = _sortBy(element, ['title']);

                    orderedJobs[key] = element;
                }
            }

            return orderedJobs;
        },

        toggleButtonLoadingClass() {
            return this.submitting ? 'button--loading' : '';
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.ready = true;
        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        async onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                formData.append('formRenderToken', this.formRenderToken);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);
                const result = response.data;

                if (result.data.errors) {
                    this.errors.clear();

                    this.errors.record(result.data.errors);
                    this.submitting = false;
                    this.scrollToFirstError();
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();
            } catch (e) {
                throw new Error(e);
            }
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                const firstError =
                    document.querySelector('.new-input__container--error') ||
                    this.$el.querySelector('.form-error-message');

                if (!firstError) {
                    return;
                }

                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },
    },
});
